






















import { Vue, Component } from "@/shared/vuepack";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";
import TransferFunds from "@/employee/components/onboarding/balance-transfer/TransferFunds.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";

@Component({
  components: {
    HsaBankOnboardingFooter,
    TransferFunds
  }
})
export default class BalanceTransfer extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  get title () {
    return this.balanceTransferStore.currentStepTitle;
  }

  get isTransferFundsStep () {
    return this.balanceTransferStore.isTransferFundsStep;
  }
}
